import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

const STATUS_CONFIG = {
  pending: { label: 'Setting up', color: 'var(--color-warning-500)', bg: 'var(--color-warning-050)' },
  scheduled: { label: 'Scheduled', color: 'var(--color-info-500)', bg: 'var(--color-info-050)' },
  joining: { label: 'Joining...', color: 'var(--color-warning-500)', bg: 'var(--color-warning-050)' },
  in_waiting_room: { label: 'Waiting', color: 'var(--color-warning-500)', bg: 'var(--color-warning-050)' },
  in_call_not_recording: { label: 'In meeting', color: 'var(--color-success-500)', bg: 'var(--color-success-050)' },
  in_call_recording: { label: 'Recording', color: 'var(--color-success-500)', bg: 'var(--color-success-050)' },
  call_ended: { label: 'Processing', color: 'var(--color-info-500)', bg: 'var(--color-info-050)' },
  done: { label: 'Processing', color: 'var(--color-info-500)', bg: 'var(--color-info-050)' },
  transcribing: { label: 'Transcribing', color: 'var(--color-info-500)', bg: 'var(--color-info-050)' },
  summarizing: { label: 'Summarizing', color: 'var(--color-info-500)', bg: 'var(--color-info-050)' },
  completed: { label: 'Completed', color: 'var(--color-success-700)', bg: 'var(--color-success-050)' },
  failed: { label: 'Failed', color: 'var(--color-danger-500)', bg: 'var(--color-danger-050)' },
  cancelled: { label: 'Cancelled', color: 'var(--color-neutral-500)', bg: 'var(--color-neutral-050)' }
}

const useStyles = makeStyles(() => ({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 8px',
    borderRadius: 'var(--border-radius-md)',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '16px',
    whiteSpace: 'nowrap'
  }
}))

function MeetingStatusBadge ({ status }) {
  const classes = useStyles()
  const config = STATUS_CONFIG[status] || { label: status, color: 'var(--color-neutral-500)', bg: 'var(--color-neutral-050)' }

  return (
    <span
      className={clsx(classes.badge)}
      style={{ color: config.color, backgroundColor: config.bg }}
    >
      {config.label}
    </span>
  )
}

MeetingStatusBadge.propTypes = {
  status: PropTypes.string.isRequired
}

export default React.memo(MeetingStatusBadge)
